import reduce from 'lodash/reduce';

import { EquipmentResponse } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import prepareCosts from '~/src/features/tariffBuilder/helpers/transformer/prepareRouters/prepareCosts';
import { IDecoderEntity } from '~/src/features/tariffBuilder/types/entity';

const prepareDecoders = (current: Record<number, IDecoderEntity>, incoming: Record<number, EquipmentResponse>) => {
    if (!incoming) {
        return {};
    }

    return reduce(incoming, (result, incomingDecoder, key) => {
        const {
            costs: incomingCosts,
            id,
            ...router
        } = incomingDecoder;

        const numericId = Number(key);
        const costs = reduce(incomingCosts, prepareCosts, {});

        if (!result[numericId]) { // the first iteration on initialization
            result[numericId] = {
                ...router,
                group: 'decoder',
                id: Number(id),
                costs,

                selectedCost: Math.max(...Object.keys(costs).map(Number)),
                quantity: 0,
            };
        } else { // others iterations, we do not need other data
            result[numericId] = {
                ...result[numericId],
                costs,
            };
        }

        return result;
    }, current);
};

export default prepareDecoders;
